// extracted by mini-css-extract-plugin
module.exports = {"dashboardCount":"DashboardCounts_dashboardCount__2jjKH"};